export const LEGAL_CONFIG = {
  serviceName: "BadmintonArbiter",
  serviceDomains: ["badmintonarbiter.com", "badmintonarbiter.pl"],
  // Osoba fizyczna, nie przedsiębiorca — stąd brak NIP/REGON. Adres jest wymagany
  // przez art. 5 ust. 2 ustawy o świadczeniu usług drogą elektroniczną.
  administratorName: "Wojciech Reza",
  administratorAddress: "ul. Kazimierza Wielkiego 5/1, 44-100 Gliwice",
  contactEmail: "wojciechreza@gmail.com",
  lastUpdated: "16 sierpnia 2026",
} as const;

// Rozdzielone świadomie: baza osobowa NIE stoi na OVH, tylko na osobnym VPS-ie.
// Wpisanie tu jednego „hostingu" było nieprawdziwe wobec art. 13 ust. 1 lit. e.
export const DATA_PROCESSORS = [
  {
    role: "Dostawca serwera aplikacji i bazy danych",
    name: "IONOS SE, Hinterm Hauptbahnhof 5, 76137 Karlsruhe, Niemcy",
    scope:
      "na jego serwerze działa aplikacja oraz przechowywana jest baza danych wraz z kopiami zapasowymi",
  },
  {
    role: "Dostawca hostingu stron",
    name: "OVH (OVH Sp. z o.o. / OVH SAS), serwery w Unii Europejskiej",
    scope:
      "na jego serwerze znajdują się pliki stron; przez ten serwer przechodzą również zapytania kierowane do aplikacji",
  },
  {
    role: "Dostawca poczty elektronicznej",
    name: "Google Ireland Limited (Gmail)",
    scope:
      "pod adresem kontaktowym obsługujemy korespondencję dotyczącą danych osobowych, w tym żądania z punktu 8",
  },
] as const;

export const PUBLIC_RESULT_SOURCES = [
  { name: "bo5.pl / CitySports", url: "https://bo5.pl" },
  { name: "hastalavista.pl (liga deblowa i open)", url: "https://hastalavista.pl" },
  { name: "deblowaliga.pl (liga Bieruń)", url: "https://deblowaliga.pl" },
  { name: "tournament.tools", url: "https://tournament.tools" },
  { name: "pzbad.tournamentsoftware.com", url: "https://pzbad.tournamentsoftware.com" },
] as const;
